import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-about-page',
  templateUrl: './about-page.component.html',
  styleUrls: ['./about-page.component.scss'],
})
export class AboutPageComponent implements OnInit {

  safeURL: SafeResourceUrl;
  videoURL = 'https://www.youtube.com/embed/5v11weV3AYA?rel=0';

  constructor(private domSanitizer: DomSanitizer) { }

  ngOnInit() {
    this.safeURL = this.domSanitizer.bypassSecurityTrustResourceUrl(this.videoURL);
  }

}
